import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  dialog: {
    gap: `${theme.spacing.space24}px`,
  },

  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: theme.spacing.space12,
  },

  form: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space16,
  },

  field: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    boxSizing: "border-box",
  },

  label: {
    paddingBottom: theme.spacing.space4,
  },

  selectControl: {
    width: "100%",
    position: "relative",
    display: "flex",
    alignItems: "center",
    borderRadius: theme.radius.small,
    border: `1px solid ${theme.colors.Border1}`,
    background: theme.colors.Background2,
    maxHeight: 48,
    padding: `${theme.spacing.space12}px ${theme.spacing.space16}px`,
    boxSizing: "border-box",
    cursor: "pointer",
    outline: "none",
  },

  selectControlActive: {
    border: `1.5px solid ${theme.colors.Border4}`,
  },

  dropdown: {
    position: "fixed",
    zIndex: 1,
  },

  select: {
    width: "100%",
    minHeight: 48,
    padding: `${theme.spacing.space12}px ${theme.spacing.space40}px ${theme.spacing.space12}px ${theme.spacing.space12}px`,
    fontSize: 16,
    lineHeight: "24px",
    color: theme.colors.TextDefault,
    background: theme.colors.Background2,
    border: `1px solid ${theme.colors.Border1}`,
    borderRadius: theme.radius.small,
    outline: "none",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    cursor: "pointer",
    boxSizing: "border-box",
  },

  placeholder: {
    color: theme.colors.TextGray,
  },

  selectIcon: {
    position: "absolute",
    insetInlineEnd: theme.spacing.space12,
    color: theme.colors.TextSilver,
    pointerEvents: "none",
    transition: "transform 0.2s ease",
  },

  selectIconOpen: {
    transform: "rotate(180deg)",
  },

  input: {
    outline: "none",
  },
}));
